import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { Dependent } from '@/modules/user/components/ManageProfile/components/Dependents/dependents.types';
import { GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY } from '@/modules/user/components/ManageProfile/components/Dependents/queries/useDependents.query';
import { formatDependentSsnToServer } from '@/utils';

const useUpdateDependentQuery = (dependentId?: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (dependent: Dependent) =>
      api.put(API_URL.V2_DEPENDENTS_BY_DEPENDENT_ID(dependentId || ''), {
        first_name: dependent.firstName,
        last_name: dependent.lastName,
        ...formatDependentSsnToServer(dependent.ssn),
        birth_on: dependent.birthOn,
        relationship_type: dependent.relationshipType,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY] });
      },
    }
  );

  return {
    updateDependent: mutateAsync,
    isLoading,
  };
};

export default useUpdateDependentQuery;
